import React from "react";
import cx from "classnames";

import "./ShadowTitle.scss";

const ShadowTitle = ({ className, children }) => (
    <h1 className={cx("shadow-title", className)}>{children}</h1>
);

export default ShadowTitle;
